import { NgModule } from '@angular/core';
import { TooltipModule } from 'primeng/tooltip';

import { ActionTooltipDirective } from './action-tooltip.directive';

/**
 * Dedicated module for the action-tooltip directive.
 *
 * Deliberately NOT part of SharedModule: SharedModule imports/exports
 * NotificationsModule, so declaring the directive there would make it
 * unusable inside notifications without a circular module import.
 * This module also re-exports PrimeNG's TooltipModule, so a single
 * `imports: [ActionTooltipModule]` gives a consumer both `pTooltip`
 * and `appActionTooltip`.
 */
@NgModule({
  imports: [TooltipModule],
  declarations: [ActionTooltipDirective],
  exports: [ActionTooltipDirective, TooltipModule],
})
export class ActionTooltipModule {}
